/**
 * define websocket endpoint
 * @param {string} options.clientId
 * @param {string} options.userId
 * @return {string}
 */
export const getWebsocketEndpoint = ({ clientId, userId }) =>
  import.meta.env.VITE_WEBSOCKET_ENDPOINT + `/ws/v1/insights/${clientId}/${userId}`;
